import { useState } from "react";

import useAddCopyRole from "~/pages/RegistryOfRole/hooks/useAddCopyRole";
import { useSetLocationData } from "~/hooks/locationData";

export default function useCopyRole(errorLogMessage: string) {
  const copyRoleMutation = useAddCopyRole();
  const setData = useSetLocationData();
  const [copyRoleId, setCopyRoleId] = useState<string | null>(null);

  const doCopy = (id: string) => {
    copyRoleMutation.mutate(
      { id, roleData: { id } },
      {
        onSuccess: (response) => {
          setCopyRoleId(null);
          setData("openChildModal", response.newRoleId, "");
        },
        onError: (error) => {
          console.error(errorLogMessage, error);
        },
      },
    );
  };

  return { copyRoleMutation, copyRoleId, setCopyRoleId, doCopy };
}
